
$(window).scroll(function(){
  if($(window).scrollTop() > 5){
     $("header.banner").addClass('scrolled');
  }
  else{
     $("header.banner").removeClass('scrolled');
  }
});;

function isMobile(){
	var ww = $(window).width();
	return ww < 800;
}

$(window).on('load', function() {
    console.log('window load block firing, you should see animations');
    $('.intro-images-wrap').addClass('animated');
});

$(document).ready(function(){

	if( $('#map').length > 0 ) {
		console.log('map detected, establishing screen dimension change listener');

		$(window).on('resize', function() {
			if( isMobile() ) {
				window.map.setZoom(1);
			} else {
				window.map.setZoom(3);
			}
		})

	}
	
	//Add data-nav to each li
	$('.nav-primary').find('li').each(function(){
		console.log("here");
		var el = $(this);
		var classes = el.attr('class').split(/\s+/);
		for(i=0; i<classes.length; i++){
			if (classes[i].indexOf('menu-') > -1){
				var tag = classes[i].split('menu-');
				tag = tag[tag.length-1];
				el.attr('data-nav', tag);
				return;
			}
		}
	});
	
	$('#menu-primary-navigation > li > a').on('click', function(e){
		var navItemAttr = $(this).parent().attr('data-nav');
		var navItem = $('div[data-nav="'+navItemAttr+'"]');
		if(navItem.length){
			e.preventDefault();
			if (!isMobile()) return;
			openNav(navItem);
		}	
	});
	
	function openNav(el){
		navItemAttr = el.attr('data-nav');
		$('li[data-nav!="'+navItemAttr+'"]').removeClass('active');
		$('div[data-nav!="'+navItemAttr+'"]').removeClass('active');
		var navItem = $('div[data-nav='+navItemAttr+']');
		navItem.addClass("active");
		el.addClass('active');			
	}
	
	//Desktop Nav...
	$("li[data-nav]").mouseenter(function() {
		if (isMobile()) return false;
		setTimeout(function(el){
			openNav(el);
		}, 300, $(this))
    });

    $("[data-nav]").mouseleave(function() {
		if (isMobile()) return false;
        var navItem = $(this).attr('data-nav');
        var timerName = navItem+"_timer";
        window[timerName]=setTimeout(function(navItem){
            $('li[data-nav="'+ navItem+'"]').removeClass('active');
            $('div[data-nav="'+ navItem+'"]').removeClass('active');
        },150, navItem);
    });

    $("[data-nav]").mousemove(function() {
		if (isMobile()) return false;
        var navItem = $(this).attr('data-nav');
        var timerName = navItem+"_timer";
        clearTimeout(window[timerName]);
    });
        
	
	$('.menu-toggle').on('click', function(e){
		e.preventDefault();
		$('nav.nav-primary').toggleClass('active');
		$(this).toggleClass('closer');
		$('.sub-nav.active').removeClass('active');
	});
	
	$('.menu-back').on('click', function(e){
		e.preventDefault();
		$('.sub-nav.active').removeClass('active');
	});
	
	
	$('.testimonials-slider').slick({
		dots:true,
		arrows:false,
		adaptiveHeight:true,
		fade: true,
	  cssEase: 'linear',
	  autoplay: true,
	  autoplaySpeed: 8000,
	});

    $('.clients-slider').slick({
        // dots: true,
        arrows: false,
        fade: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [{
            breakpoint: 800,
            settings: {
                slidesToShow: 2                
            }
        }]     
    });

    $('.clients-slider-arrows .prev-arrow').on('click', function() {
        $('.clients-slider').slick('slickPrev');
    })

    $('.clients-slider-arrows .next-arrow').on('click', function() {
        $('.clients-slider').slick('slickNext');
    })



	//Sticky Footer	
	var mh = $(window).height() - $('footer.main-footer').outerHeight();
	$('.wrap').css('minHeight', mh);

	// Locations
	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	function initMap( $el ) {

		// Find marker elements within map.
		var $markers = $el.find('.marker');

		// Create gerenic map.
		var mapArgs = {
			zoom        : $el.data('zoom') || 16,
			mapTypeId   : google.maps.MapTypeId.ROADMAP,
			styles: [
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e9e9e9"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dedede"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#333333"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f2f2f2"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
					]
				}
			]
		};
		var map = new google.maps.Map( $el[0], mapArgs );

		// Add markers.
		map.markers = [];
		$markers.each(function(){
			initMarker( $(this), map );
		});

		// Center map based on markers.
		centerMap( map );

		// Return map instance.
		return map;
	}

	/**
	 * initMarker
	 *
	 * Creates a marker for the given jQuery element and map.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @param   object The map instance.
	 * @return  object The marker instance.
	 */
	function initMarker( $marker, map ) {

		// Get position from marker.
		var lat = $marker.data('lat');
		var lng = $marker.data('lng');
		var latLng = {
			lat: parseFloat( lat ),
			lng: parseFloat( lng )
		};

		// Create marker instance.
		var marker = new google.maps.Marker({
			position : latLng,
			map: map,
			icon: location.origin + '/wp-content/themes/audiosalad/dist/images/map-marker.png'
		});

		// Append to reference for later use.
		map.markers.push( marker );

		// If marker contains HTML, add it to an infoWindow.
		if( $marker.html() ){

			// Create info window.
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});

			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, 'click', function() {
				infowindow.open( map, marker );
			});
		}
	}

	/**
	 * centerMap
	 *
	 * Centers the map showing all markers in view.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   object The map instance.
	 * @return  void
	 */
	function centerMap( map ) {

		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function( marker ){
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});

		// Case: Single marker.
		if( map.markers.length == 1 ){
			map.setCenter( bounds.getCenter() );

		// Case: Multiple markers.
		} else{
			map.fitBounds( bounds );
		}
	}
	$('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
	// end Locations
	
});

$(window).on('load', function () {
  console.log('window load block firing, you should see animations');
  $('.featured-screenshot').addClass('reveal');
  $('.platform-item-description').addClass('reveal');
  $('.intro-text-container').addClass('reveal');
  $('.site-section.clients').addClass('reveal');
  $('body').addClass('reveal');
});
function reveal() {
  var reveals = document.querySelectorAll(".scroll-reveal");

  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 0;

    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("reveal");
    }
  }
}

window.addEventListener("scroll", reveal);
	// To check the scroll position on page load
reveal();

